// OpenGraph metadata for social media sharing
// These are used to generate static HTML files with pre-rendered OG meta tags
// so that social media crawlers (which don't execute JavaScript) can read them.

// og:image URLs must be absolute — social crawlers don't resolve relative paths.
// We always emit production URLs: validation/staging links aren't shared on
// social media in practice, and using prod URLs means OG previews work even
// before a deploy injects per-env config. This is intentionally the ONLY URL
// we hardcode; every other route/asset stays relative.
export const PROD_BASE_URL = "https://atlas.hks.harvard.edu";

export const defaultData = {
  title: "The Atlas of Economic Complexity",
  ogTitle: "The Atlas of Economic Complexity by @HarvardGrwthLab",
  ogDescription:
    "Visualize global trade data and economic growth opportunities for every country",
  ogImage: "Atlas_logo.png",
};

// Explore visualization pages
export const treeMapOpenGraphData = {
  ogImage: "share_tree.png",
};

export const geoMapOpenGraphData = {
  ogImage: "share_geo.png",
};

export const stackGraphOpenGraphData = {
  ogImage: "share_stack.png",
};

export const productSpaceOpenGraphData = {
  ogImage: "share_ps.png",
};

export const feasibilityGraphOpenGraphData = {
  ogImage: "share_feasibility.png",
};

export const ringsGraphOpenGraphData = {
  ogImage: "share_rings.png",
};

// Growth Projections page
export const growthProjectionsOpenGraphData = {
  ogImage: "share_growth_projections.png",
};

// Country Profiles pages
export const countryProfilesLandingOpenGraphData = {
  ogImage: "share_country_profiles_landing.png",
};

export const countryProfilesExportBasketOpenGraphData = {
  ogImage: "share_country_profiles_export_basket.png",
};

export const countryProfilesExportComplexityOpenGraphData = {
  ogImage: "share_country_profiles_export_complexity.png",
};

export const countryProfilesScatterplotOpenGraphData = {
  ogImage: "share_country_profiles_scatterplot.png",
};

export const countryProfilesMarketBasketOpenGraphData = {
  ogImage: "share_country_profiles_market_basket.png",
};

export const countryProfilesNewProductsOpenGraphData = {
  ogImage: "share_country_profiles_new_products.png",
};

export const countryProfilesProductSpaceIntroOpenGraphData = {
  ogImage: "share_country_profiles_product_space_intro.png",
};

export const countryProfilesCountryProductSpaceOpenGraphData = {
  ogImage: "share_country_profiles_country_product_space.png",
};

export const countryProfilesRockSongOpenGraphData = {
  ogImage: "share_country_profiles_rock_song.png",
};

export const countryProfilesFeasibilityOpenGraphData = {
  ogImage: "share_country_profiles_feasibility.png",
};

export const countryProfilesTopProductsOpenGraphData = {
  ogImage: "share_country_profiles_top_products.png",
};

export const countryProfilesConclusionOpenGraphData = {
  ogImage: "share_country_profiles_conclusion.png",
};

// Market share page (uses same image as market basket for now)
export const marketShareOpenGraphData = {
  ogImage: "share_market.png",
};

// All static pages configuration
// Maps output filename (without .html) to OG data.
//
// Explore pages are NOT listed here — they're prerendered by React Router
// (see react-router.config.ts), and each viz route's meta() bakes in the
// full OG tag set via buildMeta(). Country profile pages stay here because
// they have many per-section share URLs that don't correspond to a single
// prerendered route.
//
// NOTE: Do NOT add "countries/index" here. The server uses
// countries/index.html as a fallback for all /countries/* URLs (including
// /countries/:country/:slide). If that file contains countries-specific meta
// tags, they won't match what React renders during the SPA hydration pass
// (which uses the root meta), causing #418 hydration errors. The countries
// route's meta() export handles client-side meta updates after route
// discovery, and the countries/static/*.html OG pages cover social crawlers.
export const staticPages = {
  // Country Profiles pages (served from /countries/static/)
  "countries/static/countryProfilesLandingEntry":
    countryProfilesLandingOpenGraphData,
  "countries/static/countryProfilesExportBasketEntry":
    countryProfilesExportBasketOpenGraphData,
  "countries/static/countryProfilesExportComplexityEntry":
    countryProfilesExportComplexityOpenGraphData,
  "countries/static/countryProfilesScatterPlotEntry":
    countryProfilesScatterplotOpenGraphData,
  "countries/static/countryProfilesMarketBasketEntry":
    countryProfilesMarketBasketOpenGraphData,
  "countries/static/countryProfilesNewProductsEntry":
    countryProfilesNewProductsOpenGraphData,
  "countries/static/countryProfilesProductSpaceIntroEntry":
    countryProfilesProductSpaceIntroOpenGraphData,
  "countries/static/countryProfilesCountryProductSpaceEntry":
    countryProfilesCountryProductSpaceOpenGraphData,
  "countries/static/countryProfilesRockSongEntry":
    countryProfilesRockSongOpenGraphData,
  "countries/static/countryProfilesFeasibilityEntry":
    countryProfilesFeasibilityOpenGraphData,
  "countries/static/countryProfilesTopProductsEntry":
    countryProfilesTopProductsOpenGraphData,
  "countries/static/countryProfilesConclusionEntry":
    countryProfilesConclusionOpenGraphData,
  // Growth Projections
  "countries/static/growthProjectionsLandingEntry":
    growthProjectionsOpenGraphData,
};
